function countWords(str) {
    // Create an empty object to store the word counts
    const wordCounts = {};

    // Split the string into words using a regular expression to handle various delimiters
    const words = str.toLowerCase().match(/\b\w+\b/g);

    // Iterate over each word in the array
    words?.forEach(word => {
        // If the word is already in the object, increment its count
        if (wordCounts[word]) {
            wordCounts[word]++;
        } else {
            // Otherwise, add the word to the object with a count of 1
            wordCounts[word] = 1;
        }
    });

    // Return the object with word counts
    return wordCounts;
}

export default countWords